// React
import { useContext } from "react"

// Components
import { BaseTable, NumberInput } from "components"

// Contexts
import { DataJournalContext } from "contexts"
import { useProbillList } from "../PurchaseOrder/utils"

// Form
import { Controller, useFormContext, useWatch } from "react-hook-form"

// Types
import type { DetailFormType } from "../PurchaseOrder/utils"

// Utils
import { convertNumber } from "utils"
import { useApprovalStore } from "../utils"

export function Acc(params: {
  name: {
    detail: string
    freight: string
  }
  po_id?: string
  payment?: number
  disabled_freight?: boolean
  approval_status?: number
}) {
  // Hooks
  const { tax_code } = useContext(DataJournalContext)
  const { data: databill } = useProbillList(params.po_id);
  const { isView } = useApprovalStore()

  let total_payment = 0;
  if (!params.payment) {
    if (Array.isArray(databill)) {
      total_payment = databill.reduce((acc, item) => acc + (item.total_payment || 0), 0);
    }
  } else {
    total_payment = params.payment ?? 0;
  }


  // Form
  const { control } = useFormContext()
  const detail = useWatch({
    control,
    name: params.name.detail
  })
  const freight = useWatch({
    control,
    name: params.name.freight
  })

  // Functions
  const getSubtotalItem = (item: DetailFormType): number => {
    return item.total
  }

  // Vars
  const subtotal: number = detail.reduce((acc: number, item: DetailFormType): number => {
    return acc + getSubtotalItem(item)
  }, 0)
  const tax: number = detail.reduce((acc: number, item: DetailFormType): number => {
    // Vars
    const tax_item = tax_code.data.find(i => i.value === item.tax_id)

    return acc + (getSubtotalItem(item) * (tax_item?.rate ?? 0) / 100)
  }, 0)
  const total = subtotal + freight + tax
  const totalBalance = total - Number(total_payment)

  return (
    <section className="flex flex-col lg:items-end gap-3">
      <BaseTable
        plain
        className="w-full min-w-[100px] md:max-w-[400px] text-right"
      >
        <tbody>
          <tr>
            <td className="w-[1px] whitespace-nowrap">SUBTOTAL</td>
            <td>{convertNumber(subtotal).intoCurrency}</td>
          </tr>
          <tr>
            <td className="w-[1px] whitespace-nowrap">FREIGHT</td>
            {/* <td>{convertNumber(freight).intoCurrency}</td> */}
            <Controller
              control={control}
              name="freight"
              render={({ field, fieldState }) => (
                <NumberInput
                  inputClass="text-right"
                  // disabled={params.disabled_freight ?? false }
                  readOnly={(params.disabled_freight || isView) ?? false}
                  error={fieldState.error?.message}
                  ref={field.ref}
                  value={field.value ?? 0}
                  onValueChange={e => {
                    // Vars
                    const value: number = e.floatValue ?? 0

                    field.onChange(value)
                  }}
                />
              )}
            />
          </tr>
          <tr>
            <td className="w-[1px] whitespace-nowrap">TAX</td>
            <td>{convertNumber(tax).intoCurrency}</td>
          </tr>
          <tr className="font-bold">
            <td className="w-[1px] whitespace-nowrap">TOTAL AMOUNT</td>
            <td>{convertNumber(total).intoCurrency}</td>
          </tr>
          <tr className="text-error">
            <td className="w-[1px] whitespace-nowrap">PAYMENT</td>
            <td>{convertNumber(total_payment ?? 0).intoCurrency}</td>
          </tr>
          <tr className="border-y-2 border-black text-lg font-bold">
            <td className="w-[1px] whitespace-nowrap">BALANCE</td>
            <td>{convertNumber(totalBalance).intoCurrency}</td>
          </tr>
        </tbody>
      </BaseTable>
    </section>
  )
}